// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-links-info .links-header .link-description[data-v-792465bc] {
  padding: 0 2rem;
  margin-bottom: 2rem;
}
.group-links-info .links-content[data-v-792465bc] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 2rem;
  padding-right: 0.64rem;
  height: 6rem;
}
.group-links-info .links-content .links-content-link[data-v-792465bc] {
  cursor: pointer;
  padding-left: 2rem;
  color: var(--toolbtn-active-color);
}
.group-links-info .links-content .circle-animation[data-v-792465bc] {
  font-size: 1.6em;
  margin: unset;
}
[data-v-792465bc] .loader {
  height: calc(100%);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/GroupLinksInfo.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".group-links-info .links-header .link-description[data-v-792465bc] {\n  padding: 0 2rem;\n  margin-bottom: 2rem;\n}\n.group-links-info .links-content[data-v-792465bc] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 2rem;\n  padding-right: 0.64rem;\n  height: 6rem;\n}\n.group-links-info .links-content .links-content-link[data-v-792465bc] {\n  cursor: pointer;\n  padding-left: 2rem;\n  color: var(--toolbtn-active-color);\n}\n.group-links-info .links-content .circle-animation[data-v-792465bc] {\n  font-size: 1.6em;\n  margin: unset;\n}\n[data-v-792465bc] .loader {\n  height: calc(100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
